import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '../commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import BecaService from '@/entities/seguimiento/beca.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { Programa } from '@/shared/model/seguimiento/programa.model';
import { PerfilApi } from '@conacyt/perfil-usuario-client';
import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';

@Component
export default class BecaRegistroExtranjeraComponent extends ApeironComponent {
  @Inject('becaService') public readonly becaService: () => BecaService;

  @Inject('perfilApi') public readonly perfilApi: () => PerfilApi;

  @Prop({ required: false })
  public solucion: Solucion;

  @Prop({ required: false })
  public solicitud: Solicitud;

  hasBecas = false;
  public isFetching = false;
  public solicitudUri = '';
  form = this.becaModel;

  /**
   * Se inicializa model de form
   */
  private get becaModel() {
    return {
      beca: {
        programa: new Programa(),
        solucionSolicitud: {
          nombreConvocatoria: '',
        },
        estadoActual: '',
        apoyo: {
          programa: '',
          tipoApoyo: {
            descripcion: '',
          },
          institucion: {
            descripcion: '',
          },
          pais: {
            descripcion: '',
          },
        },
        periodoBeca: {
          fechaInicioBeca: '',
          fechaFinBeca: '',
        },
      },
      tags: [],
      variablesSociodemograficas: '',
      perfil: '',
    };
  }
  get showNoBecaMessage() {
    return !this.isFetching && !this.hasBecas;
  }

  created() {
    if (this.form.tags) {
      this.form.tags = this.solucion.tags;
    }

    this.getBecaExtranjeraVigente();
    this.getGruposByCVU();
    this.getPerfilByCvu();
  }

  /**
   * Obtiene los datos de la beca vigente
   */
  getBecaExtranjeraVigente() {
    this.isFetching = true;
    this.becaService()
      .findBecaExtranjeraVigente(this.solicitud.solicitante?.cvu)
      .then(
        res => {
          this.form.beca = { ...res, ...JSON.parse(JSON.stringify(res)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  /**
   * Obtiene los datos de variables sociodemográficas
   */
  getGruposByCVU() {
    this.isFetching = true;
    this.perfilApi()
      .getGruposByCVU(this.solicitud.solicitante?.cvu)
      .then(
        res => {
          this.form.variablesSociodemograficas = { ...res.data, ...JSON.parse(JSON.stringify(res.data)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  /**
   * Obtiene los datos de perfil
   */
  getPerfilByCvu() {
    this.isFetching = true;
    this.perfilApi()
      .getPerfilByCvu(this.solicitud.solicitante?.cvu)
      .then(
        res => {
          this.form.perfil = { ...res.data, ...JSON.parse(JSON.stringify(res.data)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  public isSaving(): boolean {
    return (
      this.solicitud.estado === EstadoSolicitud.EN_CAPTURA &&
      this.grantService().isSolicitante(this.solicitud, this.grantService().getUsername(), this.grantService().getUsercvu) &&
      this.form?.beca?.estadoActual === EstadoBeca.VIGENTE
    );
  }
}
